import { render, staticRenderFns } from "./ps-std.vue?vue&type=template&id=00f89e03&lang=html&"
import script from "./ps-std.vue?vue&type=script&lang=js&"
export * from "./ps-std.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports